import { createContext } from 'react';
import { AlertProps } from '@mui/material';
import { ConnectorType } from 'src/utils/gql/types';

export type SnackbarContextType = (
  message: string,
  color?: AlertProps['severity'],
  type?: ConnectorType,
) => void;

const defaultValue: SnackbarContextType = () => {};

export const SnackbarContext = createContext<SnackbarContextType>(defaultValue);

SnackbarContext.displayName = 'SnackbarContext';
